import styled from 'styled-components';
import {
  colorAccentLighten95,
  colorBlack900,
  colorGrey400,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from 'styles';
import { Wrapper as SectionWrapper } from 'components/CurrencyExchangeTable/styles';
import { Paragraph } from 'components/Typography';

export const Wrapper = styled(SectionWrapper)``;

export const Title = styled.h4`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
  }
`;

export const ArticlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & div:last-child {
    margin-top: 16px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    column-gap: 24px;
    grid-template-columns: 1fr 1fr;
    display: grid;

    & div:last-child {
      margin-top: 0;
    }
  }
`;

export const PrimaryArticle = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.9;
  }

  img {
    display: block;
    width: 100%;
  }
`;
export const PrimaryContent = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  border-radius: 0 0 4px 4px;
  background-color: ${colorAccentLighten95};
  padding: 16px;
`;
export const SecondaryNewsContent = styled.span`
  display: flex;
  flex-direction: column;
`;

export const SecondaryNewsItem = styled.a`
  display: flex;
  background: #f6f5f8;
  border-radius: 4px;
  width: 100%;
  padding: 12px 16px;
  margin-top: 12px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

export const SecondaryNewsImg = styled.img`
  display: block;
  border-radius: 4px;
  overflow: hidden;
  width: 64px;
  height: 64px;
  margin-left: 16px;
  flex: 0 0 64px;
  object-fit: cover;
`;

export const ArticleText = styled(Paragraph)`
  line-height: 20px;
  color: ${colorBlack900};
`;

export const PrimaryTitle = styled.h2`
  line-height: 20px;
  color: ${colorBlack900};
  font-family: ${fontFamilySecondary};
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 8px;
`;

export const Category = styled.span`
  display: inline-block;
  margin-bottom: 4px;
  line-height: 18px;
  font-family: ${fontFamilyPrimary};
  font-size: 11px;
  color: ${colorGrey400};
  text-transform: uppercase;
  letter-spacing: 1px;
`;
